import React from "react";
import Requisition from "./Requisition";

const RequisitionDashboard = () => {
  return (
    <div>
      <Requisition />
    </div>
  );
};

export default RequisitionDashboard;
